import IconComponent from './Icon.component';

export * from './Icon.component';
export default IconComponent;
